
/* eslint angular/module-setter: 0 */  // --> OFF
/* eslint angular/module-getter: 0 */  // --> OFF
// "angular-eonasdan-datetimepicker": "^0.3.9",

angular.module('ae-datetimepicker', [])
  .directive('datetimepicker', [
    '$timeout',
    function ($timeout) {
      return {
        restrict: 'EA',
        require: 'ngModel',
        scope: {
          options: '=?',
          onChange: '&?',
          onClick: '&?'
        },
        link: function ($scope, $element, $attrs, ngModel) {
          var dpElement = $element.parent().hasClass('input-group') ? $element.parent() : $element;
          
          $scope.$watch('options', function (newValue) {
            var dtp = dpElement.data('DateTimePicker');
            Object.keys(newValue).forEach(function (key) {
              dtp[key](newValue[key]);
            });
          }, true);
          
          ngModel.$render = function () {
            // if value is undefined/null do not do anything, unless some date was set before
            var currentDate = dpElement.data('DateTimePicker').date();
            if (!ngModel.$viewValue && currentDate) {
              dpElement.data('DateTimePicker').clear();
            } else if (ngModel.$viewValue) {
              // otherwise make sure it is moment object
              if (!moment.isMoment(ngModel.$viewValue)) {
                ngModel.$setViewValue(
                  moment(ngModel.$viewValue, ['x', $scope.options.format])
                );
              }
              dpElement.data('DateTimePicker').date(ngModel.$viewValue);
              $timeout(_ => $scope.$emit('datetimepickerUpdated'));
            }
          };
          
          var isDateEqual = function (d1, d2) {
            return moment.isMoment(d1) && moment.isMoment(d2) && d1.valueOf() === d2.valueOf();
          };
          
          dpElement.on('dp.change', function (e) {
            if (!isDateEqual(e.date, ngModel.$viewValue)) {
              var newValue = e.date ? e.date : null;
              // Let the controls handle the model to avoid complications, just trigger on-change:
              if (typeof $scope.onChange === 'function')
                $scope.$applyAsync(function () {
                  $scope.onChange({ value: newValue });
                });
            }
          });
          
          dpElement.on('click', function () {
            $timeout(function () {
              if (typeof $scope.onClick === 'function') {
                $scope.onClick();
              }
            });
          });
          
          dpElement.datetimepicker($scope.options);
        }
      };
    }
  ]);
